import { ARBITRUM, BSC, BESC } from "./chains";

export function getIsSyntheticsSupported(_chainId: number) {
  return false;
}

export function getIsV1Supported(chainId: number) {
  return [BSC, ARBITRUM, BESC].includes(chainId);
}
